import axiosAuth from '../../axiosMain';

async function index() {
  let response = await axiosAuth.get('/consumption_meters');
  return response.data.data;
}

export default {
  index,
};
